import { ReactNode } from 'react';
import { Stack } from '@spark-web/stack';
import { Text } from '@spark-web/text';

type ListItemProps = {
  title: string;
  terms?: { termTitle?: string; message: string | ReactNode }[];
  children?: ReactNode;
};

function ListItem({ title, terms, children }: ListItemProps) {
  return (
    <Stack gap="medium">
      <Text weight="semibold" size="small">
        {title}
      </Text>
      <Text size="xsmall">
        <Stack gap="medium">
          {!!terms && terms.length > 0
            ? terms.map(({ termTitle, message }, index) => (
                <Stack gap="medium" key={termTitle ?? index} paddingY="small">
                  {termTitle && <Text weight="semibold">{termTitle}</Text>}
                  {typeof message === 'string' ? <Text>{message}</Text> : message}
                </Stack>
              ))
            : children}
        </Stack>
      </Text>
    </Stack>
  );
}

export default ListItem;
